export default __webpack_public_path__ + "static/media/tree1.0c0876ca.svg";